// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridOffset, GridWrapper } from "@conklin/MobiusOverrides/GridContainer/GridContainer";
import { productCardStyles } from "@conklin/Overrides/Widgets/ProductList/ProductListProductCard";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { css } from "styled-components";

productCardStyles.gridContainer = {
    css: css`
        display: grid;
        grid-template-columns: 120px minmax(0, 1fr) 276px;
        grid-column-gap: 20px;
        width: 100%;
        padding: 12px 0;
        ${xScreen("lte", "md")} {
            grid-template-columns: 91px minmax(0, 1fr);
            grid-template-rows: 1fr;
            grid-column-gap: 12px;
            grid-row-gap: 8px;
            &&& {
                height: 100%;
            }
        }
    `,
};

productCardStyles.productListProductImage = {
    wrapper: {
        css: css`
            margin: 0 auto;
        `,
    },
    productImage: {
        img: {
            css: css`
                height: 120px;
                object-fit: contain;
                font-size: 14px;
                ${xScreen("lte", "md")} {
                    max-height: 91px;
                }
            `,
        },
    },
};

productCardStyles.leftColumnGridItem = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 1 / 5;
        ${xScreen("lte", "md")} {
            grid-row: 1 / 2;
        }
    `,
};

productCardStyles.infoGridItem = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 1 / 5;
        ${xScreen("lte", "md")} {
            grid-row: 1 / 2;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            gap: 8px;
            > div {
                flex-grow: 0;
            }
        }
    `,
};
productCardStyles.actionsGridItem = {
    css: css`
        grid-column: 3 / 4;
        grid-row: 1 / 6;
        &&& .bottom-section {
            margin: 0;
        }
        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
            grid-row: 2 / 3;
        }
    `,
};
productCardStyles.searchScoreDataGridItem = {
    css: css`
        grid-column: 1 / 4;
        grid-row: 6 / 7;
        ${xScreen("lte", "md")} {
            grid-column: 2 / 3;
            grid-row: 3 / 4;
            &:empty {
                display: none;
            }
        }
    `,
};

productCardStyles.productPriceAndActionsStyles = {
    productGridContainer: {
        container: {
            css: css`
                max-width: unset;
                width: 100%;
                & > .top-section {
                    &,
                    & > .info-section {
                        flex-grow: 0;
                    }
                }
            `,
        },
        info: {
            css: css``,
        },
        addToCartActions: {
            css: css`
                margin-top: 8px;
                flex-wrap: wrap;
                ${xScreen("lte", "md")} {
                    gap: 12px;
                    margin-top: 0;
                }
            `,
        },
    },
    addToCartActions: {
        css: css`
            display: flex;
            align-items: end;
            gap: 8px;
            ${xScreen("lte", "md")} {
                gap: 12px;
            }
        `,
    },

    addToCartButton: {
        sizeVariant: "small",
        css: css`
            padding: 0 20px;
            white-space: nowrap;
        `,
    },
    productAvailableStyles: {
        container: {
            css: css`
                padding-bottom: 8px;
                ${xScreen("lte", "md")} {
                    width: 100%;
                }
            `,
        },
    },
    productUnitOfMeasureSelectStyles: {
        cssOverrides: {
            formField: css`
                ${xScreen("lte", "sm")} {
                    max-width: 85px;
                }
            `,
        },
    },
};

productCardStyles.productInformationStyles = {
    container: {
        gap: 0,
        css: css`
            ${GridItemStyle} {
                &:has(div:empty) {
                    display: none;
                }
            }
        `,
    },
    partNumbersGridItem: {
        width: [12, 12, 12, 6, 6],
    },
    availabilityGridItem: {
        width: [12, 12, 12, 6, 6],
        css: css`
            ${xScreen("lte", "md")} {
                &&& {
                    margin-bottom: 8px;
                }
            }
        `,
    },
    attributes: {
        container: {
            css: css`
                padding-top: 8px;
                margin-top: 8px;
                border-top: 1px solid ${color("common.border")};
            `,
        },
    },
};
